import './Pagination.css';

interface PaginationProps {
  page: number;
  totalPages: number;
  total?: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
  className?: string;
}

export function Pagination({ page, totalPages, total, onPageChange, disabled, className = '' }: PaginationProps) {
  return (
    <div className={`sui-pagination ${className}`}>
      <button
        className="sui-pagination-btn"
        disabled={page <= 1 || disabled}
        onClick={() => onPageChange(page - 1)}
      >
        Prev
      </button>
      <span className="sui-pagination-info">
        {page}/{totalPages}{total !== undefined && ` (${total})`}
      </span>
      <button
        className="sui-pagination-btn"
        disabled={page >= totalPages || disabled}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </button>
    </div>
  );
}
